import Vue from 'vue';
import Router from 'vue-router';
import DocumentGeneratorLanding from '@/views/DocumentGeneratorLanding.vue';
import DocumentGeneratorMainView from '@/views/DocumentGeneratorMainView.vue';
import SetupMainView from '@/views/SetupMainView.vue';
import CycleDatesView from '@/views/CycleDatesView.vue';
import ReportsView from '@/views/ReportsView.vue';
import MacrosView from '@/views/MacrosView.vue';
import MacroView from '@/views/MacroView.vue';
import TestsView from '@/views/TestsView.vue';
import TestView from '@/views/TestView.vue';

import store from '../store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      name: 'adgMain',
      component: DocumentGeneratorMainView,
      path: '/:clientId/adg',
    },
    {
      name: 'adgSummary',
      component: DocumentGeneratorMainView,
      path: '/:clientId/adg/summary',
    },
    {
      name: 'adgQuestion',
      component: DocumentGeneratorMainView,
      path: '/:clientId/adg/:nodeId',
    },
    {
      name: 'mdgMain',
      component: DocumentGeneratorMainView,
      path: '/:clientId/mdg',
    },
    {
      name: 'mdgSummary',
      component: DocumentGeneratorMainView,
      path: '/:clientId/mdg/summary',
    },
    {
      name: 'mdgQuestion',
      component: DocumentGeneratorMainView,
      path: '/:clientId/mdg/:nodeId',
    },
    {
      name: 'setupMain',
      component: SetupMainView,
      path: '/:clientId/setup',
    },
    {
      name: 'setupSummary',
      component: SetupMainView,
      path: '/:clientId/setup/summary',
    },
    {
      name: 'setupQuestion',
      component: SetupMainView,
      path: '/:clientId/setup/:nodeId',
    },
    {
      name: 'cycleDates',
      component: CycleDatesView,
      path: '/:clientId/cycledates',
    },
    {
      name: 'adgLanding',
      component: DocumentGeneratorLanding,
      path: '/adg',
    },
    {
      name: 'setupLanding',
      component: DocumentGeneratorLanding,
      path: '/setup',
    },
    {
      name: 'mdgLanding',
      component: DocumentGeneratorLanding,
      path: '/mdg',
    },
    {
      name: 'cycleDatesLanding',
      component: DocumentGeneratorLanding,
      path: '/cycledates',
    },
    {
      name: 'usageReport',
      component: ReportsView,
      path: '/:clientId?/reports',
    },
    {
      name: 'macros',
      component: MacrosView,
      path: '/macros',
      meta: { adminOnly: true },
    },
    {
      name: 'macro',
      component: MacroView,
      path: '/macro/:macroId?',
      meta: { adminOnly: true },
    },
    {
      name: 'tests',
      component: TestsView,
      path: '/tests',
      meta: { adminOnly: true },
    },
    {
      name: 'test',
      component: TestView,
      path: '/test/:testId?',
      meta: { adminOnly: true },
    },
    {
      name: 'api',
      path: '/*/api/*',
    },
    {
      name: 'clientIdRoot',
      path: '/:clientId',
    },
    {
      name: 'root',
      path: '/',
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        offset: { x: 0, y: 75 },
      };
    }
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach(async (to, from, next) => {
  if (to.name === 'clientIdRoot') {
    // When an fi is selected we are forced to /:clientId.  Reroute
    // depending on where we are coming from.
    if (from.fullPath.includes('/setup')) {
      next(`/${to.params.clientId}/setup`);
    } else if (from.fullPath.includes('/mdg')) {
      next(`/${to.params.clientId}/mdg`);
    } else if (from.fullPath.includes('/reports')) {
      next(`/${to.params.clientId}/reports`);
    } else if (from.fullPath.includes('/cycledates')) {
      next(`/${to.params.clientId}/cycledates`);
    } else {
      next(`/${to.params.clientId}/adg`);
    }
  } else if (to.name === 'root') {
    // If we're just going to the root, redirect to adg
    next({ name: 'adgLanding' });
  } else if (to.matched.some(record => record.meta.adminOnly)) {
    // May not have loaded the session yet, so must do so before we can check if this is an fi user
    if ((!(store.state as any).auth || !((store.state as any).auth as any).sessionData)) {
      await store.dispatch('auth/initializePortalSession');
    }

    if (!(store.state as any).auth || !((store.state as any).auth as any).sessionData
      || ((store.state as any).isFiUser) || !((store.state as any).auth.authManager.canWrite('complianceAdmin'))) {
      // Non admin user or just not logged in, so bounce.
      next({ name: 'adgLanding' });
    } else {
      next();
    }
  } else if (to.name === 'api') {
    window.location.href = to.fullPath.substring(to.fullPath.indexOf('/api'));
  } else {
    next();
  }
});

export default router;
